import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { WorkFlow } from '../../models/workflow';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProductionPlannerService } from "../productionplanner.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { isUndefined } from 'util';

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.css']
})
export class WorkFlowComponent implements OnInit {
    isUpdateWorkFlow: boolean = false;
    isWorkFLowList: boolean = true;
    ActiveStation: any[] = [];
    AllStation: any[] = [];
    AllWorkflow: any[] = [];
    modalRef: BsModalRef;
    deleteModalRef: BsModalRef;
    WFId: number = 0;
    config = {
        backdrop: true,
        ignoreBackdropClick: false
      };
    spesicWorkFlow: any = new WorkFlow();
    CDKWorkflowStation: any[] = [];
    AssignWorkflow: any[] = [];
    
    constructor(private _toastr: ToastrService, private productionPlannerService: ProductionPlannerService,
        private spinner: NgxSpinnerService, private modalService: BsModalService){}

    ngOnInit(){
      this.getActiveProductionPlannerStation();
      this.getAllProductionPlannerWorkflow();
    }

    getActiveProductionPlannerStation(){
      this.productionPlannerService.getAllProductionPlannerStation().subscribe((data: any) => {
        this.AllStation = [];
        this.AllStation = data;
        if(this.AllStation != null && this.AllStation.length > 0){
          this.ActiveStation = [];
          this.ActiveStation = this.AllStation.filter(s => s.status === true);
        }     
      }, (err) => { 
        this._toastr.error(err);
      });
    }
    getAllProductionPlannerWorkflow(){
      this.spinner.show()
      this.productionPlannerService.getAllProductionPlannerWorkflow().subscribe((data: any) => {
        this.AllWorkflow = [];
        this.AllWorkflow = data;
        if(this.AllWorkflow != null && this.AllWorkflow.length > 0){
          this.isWorkFLowList = true;
        } else{
          this.isWorkFLowList = false;
        }
        this.spinner.hide();      
      }, (err) => { 
        this._toastr.error(err); 
        this.spinner.hide(); 
      });
    }
    onSubmit(f){
      debugger;
      f.submitted = true;
      if (f.form.valid) {            
        if(this.AssignWorkflow.length == 0){
          this._toastr.warning("Please assign at least one workflow.");
        }
        else {
          this.spesicWorkFlow.WorkFlowStation = this.AssignWorkflow.map((ele: any) => ele.stationId).join(',');                
          this.spesicWorkFlow.UserId = localStorage.getItem('userid');
          this.productionPlannerService.addUpdateProductioPlannerWorkflow(this.spesicWorkFlow).subscribe((response: any) => {
            if (response == true) {
              if (this.isUpdateWorkFlow) {
                this._toastr.success("Workflow has been updated successfully");
                this.isUpdateWorkFlow = false;
              }
              else {
                this._toastr.success("Workflow has been added successfully");                    
              }
              f.submitted = false;
              this.spesicWorkFlow = new WorkFlow();
              this.getAllProductionPlannerWorkflow();
              this.closeAddUpdateWorkFlowTemp();
            }
            else {
              this._toastr.warning("Failed to Add/update work flow.");
            }
          }, (err) => { 
            this._toastr.error(err);  
          });
        }
      }
    }
    editWorkflow(item: any, template: TemplateRef<any>){
      this.isUpdateWorkFlow = true;
      this.CDKWorkflowStation = [];
      this.AssignWorkflow = [];
      this.spesicWorkFlow.WorkFlowId = item.workFlowId;
      this.spesicWorkFlow.WorkFlowName = item.workFlowName;
      this.spesicWorkFlow.WorkFlowDescription = item.workFlowDescription;
      let assignedStations = item.workFlowStationIds.split(',').map(id => +id);
      if(assignedStations != null && assignedStations != undefined && assignedStations.length > 0){
        assignedStations.forEach((ele: any) => {
          this.ActiveStation.forEach((ele1: any) => {
            if(ele == ele1.stationId){
              this.AssignWorkflow.push(ele1);              
            }
          });
        });
        this.ActiveStation.forEach((ele: any) => {
          this.CDKWorkflowStation.push(ele);
        });
        assignedStations.forEach((ele3: any) => {
          this.CDKWorkflowStation = this.CDKWorkflowStation.filter(s => s.stationId !== ele3);
        });
      } else{
        this.ActiveStation.forEach((ele: any) => {
          this.CDKWorkflowStation.push(ele);
        });
        this.AssignWorkflow = [];
      }
      this.isUpdateWorkFlow = true;
      this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'modal-medium' }, this.config));
    }
    deleteWorkflow(id: number, temp: TemplateRef<any>){
      this.WFId = id;
      this.deleteModalRef = this.modalService.show(temp);
    }
    confirm(){
      this.productionPlannerService.deleteProductionPlannerWorkflow(this.WFId).subscribe((data: any) => {
        if (data == true) {
          this._toastr.success("Workflow has been deleted successfully");
          this.getAllProductionPlannerWorkflow();
          this.deleteModalRef.hide();
        }
        else {
          this._toastr.error("Something is wrong please contact to administration");
        }
      },
      (err) => {
        this._toastr.error(err);
      });    
    }
    decline(){
      this.deleteModalRef.hide();
    }
    addNewWorkFlow(template: TemplateRef<any>) {
      this.isUpdateWorkFlow = false;
      this.spesicWorkFlow = new WorkFlow();
      this.CDKWorkflowStation = [];
      this.ActiveStation.forEach((ele: any) => {
        this.CDKWorkflowStation.push(ele);
      });
      this.AssignWorkflow = [];
      this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'modal-medium' }, this.config));
    }
    closeAddUpdateWorkFlowTemp() {
      this.modalRef.hide();
    }
    drop(event: CdkDragDrop<string[]>) {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex,
        );
      }
    }
}